const TOBACCO_API_OFFERS_BASE_URL = '/tobacco-api-offers';

export const routeCreator = {
  base: () => TOBACCO_API_OFFERS_BASE_URL,
  details: (id: ':id' | string) => `${TOBACCO_API_OFFERS_BASE_URL}/${id}`,
};
